import {
  LocalizationProvider,
  MobileTimePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import MoreAction from "./MoreAction";
import { useDispatch, useSelector } from "react-redux";
import { BatchSettingReducerAction } from "../Store/BatchScheduling/BatchSettingReducer";
import axios from "axios";
import CustomDateTime from "../CustomComponents/CustomDateTime";

const BatchSetting = () => {
  let stopClicked = false;
  //State which maintain active RowId
  const [activeRowId, setActiveRowId] = useState();
  //Dialog Handling states
  const [informationDialogVisibility, setInformationDialogVisibility] =
    useState(false);
  const [informationDialogTitle, setInformationDialogTitle] = useState("");
  const [informationDialogContent, setInformationDialogContent] = useState("");
  //Schedule button Enable Disable flag
  // const [scheduleButtonDisable, setscheduleButtonDisable] = useState(true);
  let gridRows = useSelector(
    (state) => state.batchSetting.gridRecords.gridRows
  );
  const [duplicateGridRows, setDuplicateGridRows] = useState();
  let changedGridArray = [];
  const dispatch = useDispatch();

  const autoStartTimeChangeHandler = (value) => {
    // setscheduleButtonDisable(false);
    const activeRecordIndex = gridRows.findIndex(
      (record) => record.batchId === activeRowId
    );
    let activeRow = gridRows[activeRecordIndex];
    let updatedActiveRow = {
      ...activeRow,
      autoStartTime: new Date(value),
      scheduleButtonDisable: false,
    };
    let duplicateGridRows = [...gridRows];
    duplicateGridRows[activeRecordIndex] = updatedActiveRow;
    dispatch(BatchSettingReducerAction.updateGridRows(duplicateGridRows));
  };
  const triggerStatusChangeHandler = (value, row) => {
    const activeRecordIndex = gridRows.findIndex(
      (record) => record.batchId === row.batchId
    );
    let activeRow = gridRows[activeRecordIndex];
    let updatedActiveRow = { ...activeRow, triggerStatus: value };
    let duplicateGridRows = [...gridRows];
    duplicateGridRows[activeRecordIndex] = updatedActiveRow;
    dispatch(BatchSettingReducerAction.updateGridRows(duplicateGridRows));
  };
  const batchTriggerSchedule = async (
    autoStartTime,
    batchDescription,
    batchId,
    batchName,
    recurrence,
    url
  ) => {
    try {
      const response = await axios.post(url, {
        autoStartTime,
        batchDescription,
        batchId,
        batchName,
        recurrence,
      });
      if (!stopClicked) {
        setInformationDialogVisibility(true);
        setInformationDialogTitle("Success");
        setInformationDialogContent(response.data);
      }
    } catch {
      if (!stopClicked) {
        setInformationDialogVisibility(true);
        setInformationDialogTitle("Error");
        setInformationDialogContent("Something Went Wrong.");
      }
    }
    stopClicked = false;
  };
  const triggerButtonHandler = (activeRow) => {
    const {
      batchId,
      batchDescription,
      autoStartTime,
      batchName,
      lockStatus,
      recurrence,
      triggerStatus,
    } = activeRow;
    switch (batchName) {
      case "DisbJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/disbEditLockJob"
        );
        break;

      case "NachJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/nachEditLockJob"
        );
        break;

      case "RetrievalPostingJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/retrievalPostingJob"
        );
        break;

      case "AmortLpsJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/amortLpsJob"
        );
        break;

      case "AmortDemandJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/amortDemandJob"
        );
        break;

      case "AmortNplJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/amortNplJob"
        );
        break;
      case "DataMigrationJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/dataMigrationJob"
        );
        break;
      case "LosLmsStatusUpdateJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/losLmsStatusUpdateJob"
        );
        break;
      default:
        return;
    }
  };
  const scheduleButtonHandler = (activeRow) => {
    const {
      batchId,
      batchDescription,
      autoStartTime,
      batchName,
      lockStatus,
      recurrence,
      triggerStatus,
    } = activeRow;
    switch (batchName) {
      case "DisbJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/disbEditLockJobScheduled"
        );
        break;

      case "NachJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/nachEditLockJobScheduled"
        );
        break;

      case "RetrievalPostingJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/retrievalPostingJobScheduled"
        );
        break;

      case "AmortLpsJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/amortLpsJobScheduled"
        );
        break;

      case "AmortDemandJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/amortDemandJobScheduled"
        );
        break;

      case "AmortNplJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/amortNplJobScheduled"
        );
        break;
      case "DataMigrationJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/dataMigrationJobScheduled"
        );
        break;
      case "LosLmsStatusUpdateJob":
        batchTriggerSchedule(
          autoStartTime,
          batchDescription,
          batchId,
          batchName,
          recurrence,
          "/batch/losLmsStatusUpdateJobScheduled"
        );
        break;
      default:
        return;
    }
  };
  const stopButtonHandler = async (activeRow) => {
    stopClicked = true;
    try {
      const response = await axios.post("/batch/terminateBatch", activeRow);
      if (stopClicked) {
        setInformationDialogVisibility(true);
        setInformationDialogTitle("Success");
        setInformationDialogContent(response.data);
      }
    } catch {
      if (stopClicked) {
        setInformationDialogVisibility(true);
        setInformationDialogTitle("Error!");
        setInformationDialogContent("Something Went Wrong");
      }
    }
  };
  const columnsData = [
    {
      field: "batchId",
      headerAlign: "center",
      headerName: "Batch ID",
      flex: 150,
    },
    {
      field: "batchName",
      headerAlign: "center",
      headerName: "Batch Name",
      flex: 180,
    },
    {
      field: "batchDescription",
      headerAlign: "center",
      headerName: "Batch Description",
      flex: 200,
    },
    {
      field: "autoStartTime",
      headerName: "Auto Start Time",
      headerAlign: "center",
      flex: 250,
      editable: true,

      renderCell: (params) => {
        return (
          // <LocalizationProvider dateAdapter={AdapterDayjs}>
          //   <TimePicker
          //     value={params.row.autoStartTime}
          //     onChange={(value) => {
          //       autoStartTimeChangeHandler(value);
          //     }}
          //     renderInput={(params) => (
          //       <TextField
          //         {...params}
          //         sx={{
          //           "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
          //             border: 0,
          //           },
          //         }}
          //       />
          //     )}
          //   />
          // </LocalizationProvider>
          <CustomDateTime
            value={params.row.autoStartTime}
            onChange={(value) => {
              autoStartTimeChangeHandler(value);
            }}
          />
        );
      },
    },
    {
      field: "recurrence",
      headerName: "Recurrence",
      type: "singleSelect",
      headerAlign: "center",
      editable: true,
      valueOptions: ["DAILY", "MONTHLY"],
      flex: 200,
    },
    {
      field: "triggerStatus",
      headerName: "Trigger Status",
      flex: 160,
      headerAlign: "center",
      editable: true,
      renderCell: (params) => {
        return (
          <Switch
            checked={params.row.triggerStatus}
            onChange={(value) => {
              triggerStatusChangeHandler(value.target.checked, params.row);
            }}
          ></Switch>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 150,
      align: "center",
      headerAlign: "center",

      renderCell: (params) => {
        return (
          <MoreAction
            params={params.row}
            triggerButtonHandler={triggerButtonHandler}
            scheduleButtonHandler={scheduleButtonHandler}
            stopButtonHandler={stopButtonHandler}
            // scheduleButtonDisable={scheduleButtonDisable}
          />
        );
      },
    },
  ];
  const getGridRowData = async () => {
    try {
      const response = await axios.get("/batchregister/getAllBatch");
      const dataWithKey = response.data.map((record) => {
        return {
          ...record,
          id: record.batchId,
          scheduleButtonDisable: true,
        };
      });
      dispatch(BatchSettingReducerAction.updateGridRows(dataWithKey));
      setDuplicateGridRows(dataWithKey);
    } catch {}
  };
  const cellChangeHandler = (params) => {
    const activeRecordIndex = gridRows.findIndex(
      (record) => record.batchId === params.id
    );
    const activeRow = gridRows[activeRecordIndex];
    if (params.field === "triggerStatus") {
      let updatedActiveRow = {
        ...activeRow,
        triggerStatus: params.value,
      };
      let duplicatedRows = [...gridRows];
      duplicatedRows[activeRecordIndex] = updatedActiveRow;
      dispatch(BatchSettingReducerAction.updateGridRows(duplicatedRows));
    }
    if (params.field === "recurrence") {
      let updatedActiveRow = {
        ...activeRow,
        recurrence: params.value,
      };
      let duplicatedRows = [...gridRows];
      duplicatedRows[activeRecordIndex] = updatedActiveRow;
      dispatch(BatchSettingReducerAction.updateGridRows(duplicatedRows));
    }
  };

  const saveButtonHandler = () => {
    let result = JSON.stringify(gridRows) === JSON.stringify(duplicateGridRows);
    if (result) {
      setInformationDialogVisibility(true);
      setInformationDialogTitle("Information");
      setInformationDialogContent("No Record Changes.");
    } else {
      gridRows.forEach((data, index) => {
        if (
          JSON.stringify(gridRows[index]) ===
          JSON.stringify(duplicateGridRows[index])
        ) {
        } else {
          changedGridArray.push(gridRows[index]);
        }
      });
      saveUpdatedData();
    }
  };
  const saveUpdatedData = async () => {
    const response = await axios.post(
      "/batchregister/updateAllBatch",
      changedGridArray
    );
    if (response.status === 200) {
      setDuplicateGridRows(gridRows);
      setInformationDialogVisibility(true);
      setInformationDialogTitle("Success");
      setInformationDialogContent(response.data);
    } else {
      setInformationDialogVisibility(true);
      setInformationDialogTitle("Error");
      setInformationDialogContent(response.data);
    }
  };
  useEffect(() => {
    getGridRowData();
  }, []);
  return (
    <Box sx={{ marginTop: "6px" }}>
      <Box sx={{ direction: "rtl", marginBottom: "4px" }}>
        <Button
          variant="contained"
          type="submit"
          sx={{ height: "2rem" }}
          onClick={saveButtonHandler}
        >
          Save
        </Button>
      </Box>
      <CustomDataGrid
        noDataMessage="No Data."
        noDataOnFilterMessage="No Data on Applied Filter."
        rows={gridRows}
        columns={columnsData}
        rowHeight={40}
        onRowClick={(params) => {
          setActiveRowId(params.id);
        }}
        onCellEditCommit={(params) => {
          cellChangeHandler(params);
        }}
        pageSize={10}
        pageSizeOptions={[10]}
        gridLazyLoad={() => {}}
        onSortModelChange={() => { }}
        isCellEditable={() => {}}
      />
      <Dialog open={informationDialogVisibility}>
        <DialogTitle>
          <h4>{informationDialogTitle}</h4>
        </DialogTitle>
        <DialogContent>{informationDialogContent}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setInformationDialogVisibility(false);
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default BatchSetting;
